import { isoZ, z } from 'my-zod'

export const refundTimingPolicyOptions = ['immediate', 'afterPayout'] as const
export const payoutScheduleOptions = ['daily', 'weekly', 'monthly', 'stripeControlled'] as const
export const daysOfWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'] as const

export const outfitterFinancialConfigurationModel = z.object({
  shortId: z.string(),
  outfitterId: z.number(),
  refundTimingPolicy: z.discriminatedUnion('policy', [
    z.object({ policy: z.literal('immediate') }),
    z.object({
      policy: z.literal('afterPayout'),
      daysAfterPayout: z.number()
    })
  ]),
  payoutPolicy: z.object({
    schedule: z.discriminatedUnion('interval', [
      z.object({ interval: z.literal('stripeControlled') }),
      z.object({ interval: z.literal('daily') }),
      z.object({
        interval: z.literal('weekly'),
        weeklyAnchor: z.enum(daysOfWeek)
      }),
      z.object({ interval: z.literal('monthly'), monthlyAnchor: z.number().min(1).max(31) })
    ])
  }),
  lastModifiedDate: isoZ.instant()
})

export const outfitterFinancialConfigurationCreate = outfitterFinancialConfigurationModel.omit({
  shortId: true,
  lastModifiedDate: true
})

export type outfitterFinancialConfigurationModel = z.infer<typeof outfitterFinancialConfigurationModel>
export type outfitterFinancialConfigurationCreate = z.infer<typeof outfitterFinancialConfigurationCreate>
export type outfitterFinancialConfigurationPayoutSchedule = outfitterFinancialConfigurationModel['payoutPolicy']['schedule']
